<template>
  <div>
    <div class="v-counter theme--light">{{ result }}</div>
  </div>
</template>

<script>
export default {
  name: "Counter",
  data: () => ({
    result: "",
  }),
  props: {
    message: String,
    type: String,
  },
  methods: {
    count() {
      let counter = 5;
      if (this.type === "turkce") {
        for (let i = 0; i < this.message.length; i += 1) {
          if (
            this.message.charAt(i) === "Ş" ||
            this.message.charAt(i) === "ş" ||
            this.message.charAt(i) === "ö" ||
            this.message.charAt(i) === "Ö" ||
            this.message.charAt(i) === "ü" ||
            this.message.charAt(i) === "Ü" ||
            this.message.charAt(i) === "Ğ" ||
            this.message.charAt(i) === "ğ" ||
            this.message.charAt(i) === "Ç" ||
            this.message.charAt(i) === "ç" ||
            this.message.charAt(i) === "ı" ||
            this.message.charAt(i) === "İ" ||
            this.message.charAt(i) === "€" ||
            this.message.charAt(i) === "{" ||
            this.message.charAt(i) === "}" ||
            this.message.charAt(i) === "[" ||
            this.message.charAt(i) === "]" ||
            this.message.charAt(i) === "~" ||
            this.message.charAt(i) === "^" ||
            this.message.charAt(i) === "\\" ||
            this.message.charAt(i) === "|" ||
            this.message.charAt(i) === "\r" ||
            this.message.charAt(i) === "\n"
          ) {
            counter += 2;
          } else {
            counter += 1;
          }
        }
        if (counter < 156) {
          this.result = `1 SMS / ${counter} Karakter`;
        } else if (counter > 155 && counter < 295) {
          this.result = `2 SMS / ${counter} Karakter`;
        } else if (counter > 294 && counter < 442) {
          this.result = `3 SMS / ${counter} Karakter`;
        } else if (counter > 441 && counter < 589) {
          this.result = `4 SMS / ${counter} Karakter`;
        } else if (counter > 588 && counter < 736) {
          this.result = `5 SMS / ${counter} Karakter`;
        } else if (counter > 735 && counter < 883) {
          this.result = `6 SMS / ${counter} Karakter`;
        } else if (counter > 882) {
          this.result = "Mesaj uzunluğu 882 karakterden fazla olmamalı.";
        }
      } else {
        counter = 5;
        for (let i = 0; i < this.message.length; i += 1) {
          if (
            this.message.charAt(i) === "€" ||
            this.message.charAt(i) === "{" ||
            this.message.charAt(i) === "}" ||
            this.message.charAt(i) === "[" ||
            this.message.charAt(i) === "]" ||
            this.message.charAt(i) === "~" ||
            this.message.charAt(i) === "^" ||
            this.message.charAt(i) === "\\" ||
            this.message.charAt(i) === "|" ||
            this.message.charAt(i) === "\r" ||
            this.message.charAt(i) === "\n"
          ) {
            counter += 2;
          } else {
            counter += 1;
          }
        }
        if (counter < 161) {
          this.result = `1 SMS / ${counter} Karakter`;
        } else if (counter > 160 && counter < 307) {
          this.result = `2 SMS / ${counter} Karakter`;
        } else if (counter > 306 && counter < 460) {
          this.result = `3 SMS / ${counter} Karakter`;
        } else if (counter > 459 && counter < 613) {
          this.result = `4 SMS / ${counter} Karakter`;
        } else if (counter > 612 && counter < 766) {
          this.result = `5 SMS / ${counter} Karakter`;
        } else if (counter > 765 && counter < 919) {
          this.result = `6 SMS / ${counter} Karakter`;
        } else if (counter > 918) {
          this.result = "Mesaj uzunluğu 918 karakterden fazla olmamalı.";
        }
      }
      this.$emit("update:count", counter);
    },
  },
  watch: {
    message() {
      this.count();
    },
    type(v) {
      this.count();
    },
  },
  mounted() {
    this.count();
  },
};
</script>
